<template>
  <div>
    <DownloadStat></DownloadStat>
  </div>
</template>

<script>
import DownloadStat from '../components/DownloadStat.vue';

export default {
  components: {
    DownloadStat,
  },
};
</script>
